<template>
  <el-dialog :title="title" :visible.sync="leaningVisible" width="1100px" :before-close="handleClose">
    <div class="follow-class">
      <h3 class="tit mb10">{{$t('Class.S_title')}}</h3>
      <div class="all-situation text-1">
        <ul class="clearFloat">
          <!-- <li class="pull-left flex-al">
            <label style="width: 100px;" for>{{$t('Class.label_text1')}}</label>
            <el-input
              v-model="selectForm.className"
              @keyup.enter.native="handClickselect()"
              @blur="handClickselect()"
              :placeholder="$t('Class.placeholder1')"
            ></el-input>
          </li> -->
          <li class="pull-left flex-al">
            <!-- <label for>{{$t('Class.label_text2')}}</label> -->
            <el-select
              filterable
              clearable
              class="select-md-teacher"
              @change="handClickselect()"
              v-model="selectForm.course_id"
              :placeholder="$t('Class.placeholder4')"
            >
              <el-option
                v-for="(item,index) in selectForm.courselist"
                :key="index"
                :label="`${item.course_cnname}(${item.course_branch})`"
                :value="item.course_id"
              ></el-option>
            </el-select>
          </li>
          <li class="pull-left flex-al">
            <!-- <label for>{{$t('Class.label_text2')}}</label> -->
            <el-select
              filterable
              clearable
              class="select-md-teacher"
              @change="handClickselect()"
              v-model="selectForm.teacher"
              :placeholder="$t('Class.placeholder2')"
            >
              <el-option
                v-for="item in courseName"
                :key="item.staffer_id"
                :label="item.staffer_cnname"
                :value="item.staffer_id"
              ></el-option>
            </el-select>
          </li>
          <li class="pull-left flex-al">
            <!-- <label for>{{$t('Class.label_text3')}}</label> -->
            <el-date-picker
              @change="handClickselect()"
              v-model="selectForm.time"
              :picker-options="pickerOptionsStart"
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('Class.placeholder3')"
            ></el-date-picker>
          </li>
        </ul>
      </div>
      <div class="list-box mt10">
        <classTable
          :list="tryClasslist"
          :options="Classoptions"
          :columns="ClasslistColumn"
          :operates="ClassOperates"
          @openDetails="openDetails"
        ></classTable>
      </div>
    </div>
    <span slot="footer" class="dialog-footer clearFloat">
      <div class="text-1 pull-left">
        <span class="font-333">{{$t('Class.label_text4')}}</span>
        <span class="font-red" v-html="ClassName"></span>
      </div>
      <el-button type="primary" @click="handClickcompare(classInfo)">{{$t('Common.btn_complete')}}</el-button>
      <el-button @click="handClickcancel()">{{$t('Common.btn_cancel')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import classTable from "../Table/classTable.vue";
import storeClass from "./Class.js";
export default {
  name: "auditClass",
  props: ["leaningVisible", "auditionGenre", "Auditiontime", "leaningFilterData"],
  data() {
    return {
      selectForm: {
        course_id:'',//课程id
        className: "",
        teacher: "",
        time: "",
        courselist:[]//课程列表
      },
      currentPage: 1,
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      //selcet 搜索
      courseName: [],
      audition_genre: "", // 试听类型
      //试听课程表格结束
      ClasscolumnWidth: ["150", "150", "250", "auto"],
      tryClasslist: [],
      ClasslistColumn: [],
      Classoptions: {
        mutiSelect: false, // 是否支持列表项选中功能
        highlightCurrentRow: false, // 是否支持当前行高亮显示
        tableHeight: Number, //表格高度
        errortip: ""
      },
      ClassName: "",
      classInfo: {}, // 选择的班级信息
      ClassOperates: {
        width: 200,
        label: this.$t('Common.operatesLabel'),
        align: "center",
        fixed: "right",
        list: []
      },
      //限制开始时间
      pickerOptionsStart: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    };
  },
  components: {
    classTable
  },
  created() {
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    // let current_time= this.$Common.getDate(0);//获取当前时间
    // this.selectForm.time=current_time;
    this.getAuditionStafferData(); // 获取教师
    this.Classoptions.tableHeight = this.$Common.getTableHeight(600); //设置表格高度
    // this.getAuditionData(this.pagenum);
  },
  watch: {
    getleaningVisible(n) {
      if (n) {
        let current_time = this.$Common.getDate(0); //获取当前时间
        this.selectForm.className='';
        this.selectForm.teacher='';
        this.selectForm.course_id='';
        if (this.selectForm.time == "" || this.selectForm.time == null) {
          this.selectForm.time = current_time;
        }
        this.audition_genre = this.auditionGenre;
        this.ClassName = "";
        this.getAuditionData(this.pagenum);
      }
    },
    getauditionGenre(n) {
      this.audition_genre = n;
    },
    getAuditiontime(n) {
      
      this.selectForm.time = n;
    }
  },
  computed: {
    getleaningVisible() {
      return this.leaningVisible;
    },
    // 试听类型
    getauditionGenre() {
      return this.auditionGenre;
    },
    // 试听时间
    getAuditiontime() {
      return this.Auditiontime;
    },
    title () {
      return this.audition_genre=='0' ? '普通公开课试听' :
        this.audition_genre==1 ? '插班试听' :
        this.audition_genre==2 ? '试读公开课试听' : ''
    }
  },
  methods: {
    //试听跟进->获取试听班级
    getAuditionData() {
      console.log(this.leaningFilterData, 'leaningFilterData')
      const params = {
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        audition_genre: this.audition_genre,
        // is_count: "1", //是否需要总数，可以不传
        // p: this.pagenum,
        // num: this.pagesize,
        // 非必须传
        hour_day: this.selectForm.time,
        re_staffer_id: this.selectForm.teacher,
        course_id:this.selectForm.course_id,
        course_cnname: this.selectForm.className,
      };
      if (this.audition_genre == 1 && this.leaningFilterData) {
        params.coursecat_id = this.leaningFilterData.coursecat_id;
        params.coursetype_id = this.leaningFilterData.coursetype_id;
      }
      storeClass
        .getAudition(params)
        .then(res => {
          //
          let list=res.data.data.list;
          let field=res.data.data.field; 
          this.tryClasslist =list?list:[];
          field[0].isfixed=true;
          field[0].fixed='left';
          field[1].isfixed=true;
          field[1].fixed='left';
          this.selectForm.courselist=res.data.data.courselist;
          this.ClasslistColumn = field;
          (() => {})(this.ClasslistColumn)
          this.Classoptions.errortip = res.data.msg;
        });
    },
    // 获取教师
    getAuditionStafferData() {
      storeClass
        .getAuditionStaffer({
          company_id: this.company_id,
          marketer_id: this.marketer_id,
          token: this.token,
          school_id: this.school_id
        })
        .then(res => {
          this.courseName = res.data.data.list;
          // this.courseName.unshift({
          //   staffer_id: "",
          //   staffer_cnname: this.$t('Common.options')
          // });
        });
    },
    // 点击表格
    openDetails(row) {
      
      this.classInfo = row;
      this.ClassName = `${row.class_cnname}<span class='ml10'>${this.$t('Class.label_text5')}${row.hour_day}</span><span class='ml10'>${this.$t('Class.label_text6')}${row.hour_time}</span>`;
    },
    // 筛选
    handClickselect() {
      this.getAuditionData(this.pagenum);
    },
    handleClose(done) {
      this.$emit("handleClose", done);
      // this.$confirm("确认关闭？")
      //     .then(_ => {
      //         
      //         done();
      //     })
      //     .catch(_ => {
      //         
      //     });
    },
    handClickcompare(v) {
      this.$emit("handClickcompare", v);
    },
    handClickcancel() {
      this.$emit("handClickcancel");
    }
    // hideSliderBoxEdit() {
    //   this.$emit("hideSliderBoxEdit");
    // }
  }
};
</script>

<style lang="less">
.select-md-teacher {
  width: 220px;
  .el-input{
    width: 100%!important;
  }
}
</style>
